import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { db, firebase } from "firebase/fbConfig.js"

// react component for creating dynamic tables
import ReactTable from "react-table";
import { simpleTableObject } from "components/Table/createReactTableObject.jsx"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "components/Card/Card.jsx";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Dvr from "@material-ui/icons/Dvr";
import Favorite from "@material-ui/icons/Favorite";
import Check from '@material-ui/icons/Check';
import Close from "@material-ui/icons/Close";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import ProfilePicUpload from "components/CustomUpload/profilePicUpload"
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Table from "components/Table/Table.jsx";
import NavPills from "components/NavPills/NavPills.jsx";


import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import Style from "assets/jss/material-dashboard-pro-react/views/profileStyle";
import { Grid } from "@material-ui/core";

// Forms
import VendorProfileForm from "components/Forms/vendorProfileForm.jsx"
import JobApplicationForm from "components/Forms/JobApplicationForm.jsx"

// Assets
import DefaultProfile from "assets/img/default-avatar.png"

// Firebase Redux Integration
import { tableToFirestoreObjects, updateFirestoreWithOneObject, updateFirestoreWithTableData, addFieldToDocument } from "store/actions/firestoreActions"
import { startSetActionsList, startToggleCompleted, setUserScore } from "store/actions/actionsActions"
import { startSetVendorsList } from "../../store/actions/vendorsActions"
import CreateTruckForm from "../../components/Forms/CreateTruckForm";
import CreateTrailerForm from "../../components/Forms/CreateTrailerForm";
import AssociatePersonForm from "../../components/Forms/AssociatePersonForm";

const Transition = (props) => {
  return <Slide direction="down" {...props} />
}

class Orders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      truckDataLoaded: false,
      trailerDataLoaded: false,
      userDataLoaded: false,
      updateProfileModal: false,
      updatePhotoModal: false,
      truckColumns: [
        {
          Header: "DETAILS",
          accessor: "id",
          Cell: ({ value }) => (<Link to={`${this.props.id}/truck/${value}`}><button>Details</button></Link>),
          sortable: false,
          filterable: false
        },
        {
          Header: "INTERNAL ID",
          accessor: "internalID"
        },
        {
          Header: "TYPE",
          accessor: "truckType"
        },
        {
          Header: "MAKE",
          accessor: "make"
        },
        {
          Header: "DRIVER",
          accessor: "driverName"
        },
        {
          Header: "TRAILER",
          accessor: "trailerID"
        }
      ],
      trailerColumns: [
        {
          Header: "DETAILS",
          accessor: "id",
          Cell: ({ value }) => (<Link to={`${this.props.id}/trailer/${value}`}><button>Details</button></Link>),
          sortable: false,
          filterable: false
        },
        {
          Header: "INTERNAL ID",
          accessor: "internalID"
        },
        {
          Header: "TYPE",
          accessor: "trailerType"
        },
        {
          Header: "FEET",
          accessor: "feet"
        },
        {
          Header: "DRIVER",
          accessor: "driverName"
        },
        {
          Header: "TRUCK",
          accessor: "truckID"
        }
      ],
      userColumns: [
        {
          Header: "DETAILS",
          accessor: "id",
          Cell: ({ value }) => (<Link to={`/user/${value}`}><button>Details</button></Link>),
          sortable: false,
          filterable: false
        },
        {
          Header: "NAME",
          accessor: "name"
        }      
      ]



    };
  }

  handleClickOpen = (modal) => {
    var x = [];
    x[modal] = true;
    this.setState({
      ...x,
    });
  }

  handleClose = (modal) => {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }

  loadData = () => {
    this.setState({
      vendors: simpleTableObject(this.props.vendors),
      dataLoaded: true
    })
  }

  loadVendorsData = (id) => {
    console.log("loading vendor data")
    let data = db.collection("TEST-orders").doc(id)
      .get().then((snapshot) => {
        var docData = snapshot.data()
        if (docData) {
          var docObj = {
            id: snapshot.id,
            name: docData.name ? docData.name : "N/A",
            physicalAddress: docData.physicalAddress ? docData.physicalAddress : "N/A",
            accountingNotes: docData.accountingNotes ? docData.accountingNotes : "N/A",
            creditCardInterface: docData.creditCardInterface ? docData.creditCardInterface : "N/A",
            dotNumber: docData.dotNumber ? docData.dotNumber : "N/A",
            dpo: docData.dpo ? docData.dpo : "N/A",
            insuranceinformation: docData.insuranceinformation ? docData.insuranceinformation : "N/A",
            locationNotes: docData.locationNotes ? docData.locationNotes : "N/A",
            mailingAddress: docData.mailingAddress ? docData.mailingAddress : "N/A",
            mainPhone: docData.mainPhone ? docData.mainPhone : "N/A",
            mcmxffNumber: docData.mcmxffNumber ? docData.mcmxffNumber : "N/A",
            remit: docData.remit ? docData.remit : "N/A",
            vendorType: docData.vendorType ? docData.vendorType : "N/A",
            }
          return (docObj)
        } else {
          return (null)
        }
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(docObj => {
        this.setState({
          data: docObj,
          dataLoaded: true
        })
      })
    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }


  loadVendorTrucksData = (id) => {
    let data = db.collection("TEST-vendors").doc(id).collection("trucks")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            ...docData,
            id: doc.id,
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        this.setState({
          truckData: data,
          truckDataLoaded: true,
        })
      })

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }

  loadVendorTrailersData = (id) => {
    let data = db.collection("TEST-vendors").doc(id).collection("trailers")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            ...docData,
            id: doc.id,
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        this.setState({
          trailerData: data,
          trailerDataLoaded: true,
        })
      })

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }
  
  loadVendorUsersData = (id) => {
    let data = db.collection("TEST-shippers").doc(id).collection("users")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            ...docData,
            id: doc.id,
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        this.setState({
          userData: data,
          userDataLoaded: true,
        })
      })

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }





  render() {
    const { AuthBool, classes, user, id } = this.props;

    let vendor = ""

    // if (this.state.vendors) {
    //   console.log(this.state.vendors)
    //   var currentVendor = this.state.vendors.filter(function (el) {
    //     return el.vendorID == id ;
    //   });
    //   vendor = (currentVendor[0])
    // }


    if (this.state.dataLoaded) {
      vendor = this.state.data
    }

    let profilePhoto = DefaultProfile
    if (AuthBool) { // fixes freeze on logout
      if (user.dataLoaded) {
        user.profileURL ? (
          profilePhoto = user.profileURL
        ) : (
            // add link to profile photo to firestore
            profilePhoto = !!this.props.authUser.photoURL ? this.props.authUser.photoURL : DefaultProfile
            // add profile photo to firebase storage        
            // update redux with link
          )
      }
    }

    if (user.dataLoaded
      && !this.state.dataLoaded) {
      this.loadVendorsData(id);
      this.loadVendorTrucksData(id);
      this.loadVendorTrailersData(id);
      this.loadVendorUsersData(id)
    }

    // console.log(this.state)
    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={10}>
          {this.state.dataLoaded && vendor ? (
            <GridContainer>
              <GridItem xs={12}>
                <h1 className={classes.title}>
                  ORDER</h1>
              </GridItem>
              <GridItem xs={12} sm={12} lg={12}>
              <h2>ADDRESSING</h2>

              <h4 className={classes.subTitle}>NAME:</h4>
                {vendor.name ? <p className={classes.body}>{vendor.name} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>PHYSICAL ADDRESS:</h4>
                {vendor.physicalAddress ? <p className={classes.body}>{vendor.physicalAddress} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>MAIN PHONE:</h4>
                {vendor.mainPhone ? <p className={classes.body}>{vendor.mainPhone} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>LOCATION NOTES:</h4>
                {vendor.locationNotes ? <p className={classes.body}>{vendor.locationNotes} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>PICTURE OF BUILDING:</h4>
                {vendor.vendorName ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>REMIT TO PARENT CONNECTION:</h4>
                {vendor.remit ? <p className={classes.body}>{vendor.remit} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>VENDOR TYPE:</h4>
                {vendor.vendorType ? <p className={classes.body}>{vendor.vendorType} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}

              </GridItem>
              <GridItem xs={12} sm={12} lg={12}>
              <h2>ACCOUNTING / REGULATORY</h2>
              <h4 className={classes.subTitle}>MAILING ADDRESS:</h4>
                {vendor.mailingAddress ? <p className={classes.body}>{vendor.mailingAddress} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}

                <h4 className={classes.subTitle}>ACCOUNTING NOTES:</h4>
                {vendor.accountingNotes ? <p className={classes.body}>{vendor.accountingNotes} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>CREDIT CARD INTERFACE:</h4>
                {vendor.creditCardInterface ? <p className={classes.body}>{vendor.creditCardInterface} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>DPO:</h4>
                {vendor.dpo ? <p className={classes.body}>{vendor.dpo} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>CONTACTS:</h4>
                {vendor.vendorName ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>LIST OF DRIVERS with STA:</h4>
                {vendor.vendorName ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>INSURANCE INFORMATION:</h4>
                {vendor.insuranceinformation ? <p className={classes.body}>{vendor.insuranceinformation} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>DOT NUMBER:</h4>
                {vendor.dotNumber ? <p className={classes.body}>{vendor.dotNumber} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>MC/MX/FF NUMBER:</h4>
                {vendor.mcmxffNumber ? <p className={classes.body}>{vendor.mcmxffNumber} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>CARRIER RATING:</h4>
                {vendor.vendorName ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}

              </GridItem>
              <GridItem xs={12} sm={12} lg={12}>
                <h4 className={classes.subTitle}>ADDITIONAL SERVICES:</h4>
                {vendor.vendorName ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h2>ANALYTICS</h2>

                <h4 className={classes.subTitle}>ON TIME RATING:</h4>
                {vendor.vendorName ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>FAILURE LIST:</h4>
                {vendor.vendorName ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>AVERAGE PRICE PER n:</h4>
                {vendor.vendorName ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>AVAILIBILITY RATING:</h4>
                {vendor.vendorName ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>CUSTOMER/LOGISTICIAN REVIEW:</h4>
                {vendor.vendorName ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
              </GridItem>
              <GridItem xs={12} sm={12} lg={12}>
                <GridItem xs={12} sm={12} lg={12}>
                  <h2 style={{ margin: "0" }}>PERSONNEL</h2>
                  <GridContainer>
                    <GridItem xs={6}>
                      <Button
                        color="primary"
                        onClick={() => this.handleClickOpen("updatePersonModal")}
                      >ADD NEW PERSON</Button>
                    </GridItem>
                    <GridItem xs={6}>

                    </GridItem>
                  </GridContainer>
                  <ReactTable
                    data={this.state.userData}
                    filterable
                    columns={this.state.userColumns}
                    defaultPageSize={10}
                    defaultSorted={[
                      {
                      }
                    ]}
                    //showPaginationTop
                    showPaginationBottom
                    style={{
                      color: "#000"
                    }}
                    className="-striped -highlight"
                  />

                </GridItem>

                <h4 className={classes.subTitle}>ADDITIONAL SERVICES:</h4>
                {vendor.vendorName ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}


                <h2>ANALYTICS</h2>

                <h4 className={classes.subTitle}>ON TIME RATING:</h4>
                {vendor.vendorName ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>FAILURE LIST:</h4>
                {vendor.vendorName ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>AVERAGE PRICE PER n:</h4>
                {vendor.vendorName ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>AVAILIBILITY RATING:</h4>
                {vendor.vendorName ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>CUSTOMER/LOGISTICIAN REVIEW:</h4>
                {vendor.vendorName ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <Button
                  color="primary"
                  onClick={() => this.handleClickOpen("updateProfileModal")}
                >UPDATE</Button>

              </GridItem><br />

              {/* UPDATE PROFILE MODAL */}
              <Dialog
                // classes={{
                //   root: classes.modalRoot,
                //   paper: classes.modal + " " + classes.modalSmall
                // }}
                style={{ height: "auto" }}
                open={this.state.updateProfileModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => this.handleClose("updateProfileModal")}
                aria-labelledby="shipment-modal-slide-title"
                aria-describedby="shipment-modal-slide-description"
              >
                <DialogTitle
                  id="shipment-modal-slide-title"
                  disableTypography
                  className={classes.modalHeader}
                >
                  <Button
                    simple
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updateProfileModal")}
                  >
                    {" "}
                    <Close className={classes.modalClose} />
                  </Button>
                  <h2 className={classes.modalTitle}>EDIT PROFILE</h2>
                </DialogTitle>
                <DialogContent
                  id="shipment-modal-slide-description"
                  className={classes.modalBody}
                >
                  {/* FORM */}
                  {/* {console.log(vendor)} */}
                  <VendorProfileForm
                    id={id}
                    vendor={vendor}
                    modalOpen={this.state.updateProfileModal}
                  />

                  <Button
                    style={{
                      backgroundColor: "black",
                      marginLeft: "10px",
                      marginTop: "10px"
                    }}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updateProfileModal")}
                  >
                    CLOSE
                  </Button>
                </DialogContent>
              </Dialog>

              {/* UPDATE PROFILE PHOTO MODAL */}
              <Dialog
                classes={{
                  root: classes.modalRoot,
                  paper: classes.modal + " " + classes.modalSmall
                }}
                open={this.state.updatePhotoModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => this.handleClose("updatePhotoModal")}
                aria-labelledby="shipment-modal-slide-title"
                aria-describedby="shipment-modal-slide-description"
              >
                <DialogTitle
                  id="shipment-modal-slide-title"
                  disableTypography
                  className={classes.modalHeader}
                >
                  <Button
                    simple
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updatePhotoModal")}
                  >
                    {" "}
                    <Close className={classes.modalClose} />
                  </Button>
                  <h2 className={classes.modalTitle}>UPDATE PROFILE PHOTO</h2>
                </DialogTitle>
                <DialogContent
                  id="shipment-modal-slide-description"
                  className={classes.modalBody}
                >

                  {/* FORM */}
                  <ProfilePicUpload
                    currentPic={profilePhoto}
                    username={this.props.user.username ? this.props.user.username : null}
                    uid={this.props.authUser.uid}
                  />
                  <div
                    style={{
                      textAlign: "center"
                    }}
                  >
                    <Button
                      className={classes.ltrButtonWhite}

                      key="close"
                      aria-label="Close"
                      onClick={() => this.handleClose("updatePhotoModal")}
                    >
                      CANCEL
                  </Button>
                  </div>
                </DialogContent>
              </Dialog>

              {/* UPDATE TRUCK MODAL */}
              <Dialog
                // classes={{
                //   root: classes.modalRoot,
                //   paper: classes.modal + " " + classes.modalSmall
                // }}
                style={{ height: "auto" }}
                open={this.state.updateTrucksModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => this.handleClose("updateTrucksModal")}
                aria-labelledby="shipment-modal-slide-title"
                aria-describedby="shipment-modal-slide-description"
              >
                <DialogTitle
                  id="shipment-modal-slide-title"
                  disableTypography
                  className={classes.modalHeader}
                >
                  <Button
                    simple
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updateTrucksModal")}
                  >
                    {" "}
                    <Close className={classes.modalClose} />
                  </Button>
                  <h2 className={classes.modalTitle}>ADD NEW TRUCK</h2>
                </DialogTitle>
                <DialogContent
                  id="shipment-modal-slide-description"
                  className={classes.modalBody}
                >
                  {/* {console.log(id)} */}
                  {/* FORM */}
                  <CreateTruckForm
                    id={id}
                    vendor={vendor}
                    modalOpen={this.state.updateTrucksModal}
                  />

                  <Button
                    style={{
                      backgroundColor: "black",
                      marginLeft: "10px",
                      marginTop: "10px"
                    }}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updateTrucksModal")}
                  >
                    CLOSE
                  </Button>
                </DialogContent>
              </Dialog>

              {/* UPDATE TRAILER MODAL */}
              <Dialog
                // classes={{
                //   root: classes.modalRoot,
                //   paper: classes.modal + " " + classes.modalSmall
                // }}
                style={{ height: "auto" }}
                open={this.state.updateTrailersModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => this.handleClose("updateTrailersModal")}
                aria-labelledby="shipment-modal-slide-title"
                aria-describedby="shipment-modal-slide-description"
              >
                <DialogTitle
                  id="shipment-modal-slide-title"
                  disableTypography
                  className={classes.modalHeader}
                >
                  <Button
                    simple
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updateTrailersModal")}
                  >
                    {" "}
                    <Close className={classes.modalClose} />
                  </Button>
                  <h2 className={classes.modalTitle}>ADD NEW TRAILER</h2>
                </DialogTitle>
                <DialogContent
                  id="shipment-modal-slide-description"
                  className={classes.modalBody}
                >
                  {/* {console.log(id)} */}
                  {/* FORM */}
                  <CreateTrailerForm
                    id={id}
                    vendor={vendor}
                    modalOpen={this.state.updateTrailersModal}
                  />

                  <Button
                    style={{
                      backgroundColor: "black",
                      marginLeft: "10px",
                      marginTop: "10px"
                    }}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updateTrailersModal")}
                  >
                    CLOSE
                  </Button>
                </DialogContent>
              </Dialog>

                  {/* UPDATE PERSON MODAL */}
                            <Dialog
                // classes={{
                //   root: classes.modalRoot,
                //   paper: classes.modal + " " + classes.modalSmall
                // }}
                style={{ height: "auto" }}
                open={this.state.updatePersonModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => this.handleClose("updatePersonModal")}
                aria-labelledby="shipment-modal-slide-title"
                aria-describedby="shipment-modal-slide-description"
              >
                <DialogTitle
                  id="shipment-modal-slide-title"
                  disableTypography
                  className={classes.modalHeader}
                >
                  <Button
                    simple
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updatePersonModal")}
                  >
                    {" "}
                    <Close className={classes.modalClose} />
                  </Button>
                  <h2 className={classes.modalTitle}>ADD NEW PERSON</h2>
                </DialogTitle>
                <DialogContent
                  id="shipment-modal-slide-description"
                  className={classes.modalBody}
                >
                  {/* {console.log(id)} */}
                  {/* FORM */}
                  <AssociatePersonForm
                    id={id}
                    type={"shippers"}
                    vendor={vendor}
                    modalOpen={this.state.updatePersonModal}
                  />

                  <Button
                    style={{
                      backgroundColor: "black",
                      marginLeft: "10px",
                      marginTop: "10px"
                    }}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updatePersonModal")}
                  >
                    CLOSE
                  </Button>
                </DialogContent>
              </Dialog>



            </GridContainer>
          ) : (
              <p className={classes.body}>Loading...</p>
            )}
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    AuthBool: !!state.auth.user,
    authUser: state.auth.user,
    user: state.profile.user,
    vendors: state.vendors.shipments,
    id: ownProps.match.params.id
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    startSetVendorsList: () => dispatch(startSetVendorsList())
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(Style)
)(Orders);



// WEBPACK FOOTER //
// ./src/views/Profile/orderProfile.jsx